<script>
    import { defineComponent } from 'vue'
    import Spinner from './spinner.vue'

    export default defineComponent({
        name: 'loadingPlaceholder',
        components: { Spinner },
        props: {
            overlay: Boolean,
            radius: {
                type: Number,
                default: 48
            },
            minHeight: {
                type: Number,
                default: 128
            }
        }
    })
</script>

<template>
    <div class="loading-placeholder-container" :class="{'overlay-mode': overlay}" :style="{'min-height': `${minHeight}px`}">
        <spinner class="loading-spinner" :style="{'width': `${radius}px`, 'height': `${radius}px`}"/>
    </div>
</template>

<style>
.loading-placeholder-container {
    display: flex;
    align-items: center;
    justify-content: center;

    animation: anim-fade-in 200ms;
}

.loading-placeholder-container.overlay-mode {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: #fff6;
}

.loading-spinner {
    color: var(--color-primary, #000A);
}
</style>
